/* V2
 Horizontal Rows of Template with Remove and Auto-Add functionality
 */
import * as _ from "lodash";
import * as React from "react";
import IDietRecallMealItem from "../models/IDietRecallMealItem";
import { ORION_IMG_URL } from "../utils/AppConstants";
import AllergyItemEditor from "./itemEditor/AllergyItemEditor";
import CaseSummaryItemEditor from "./itemEditor/CaseSummaryItemEditor";
import ConcernItemEditor from "./itemEditor/ConcernItemEditor";
import ConditionItemEditor from "./itemEditor/ConditionItemEditor";
import ConditionItemWrapperEditor from "./itemEditor/ConditionItemWrapperEditor";
import CurrentMedicationItemEditor from "./itemEditor/CurrentMedicationItemEditor";
import DiagnosticLabTestItemEditor from "./itemEditor/DiagnosticLabTestItemEditor";
import DietGuidelineItemEditor from "./itemEditor/DietGuidelineItemEditor";
import DietRecallItemEditor from "./itemEditor/DietRecallItemEditor";
import DietThemeItemEditor from "./itemEditor/DietThemeItemEditor";
import DoctorReferralItemEditor from "./itemEditor/DoctorReferralEditor";
import FitnessPlanGuidelinesItemEditor from "./itemEditor/FitenssPlanGuidelinesItemEditor";
import FitnessPlanItemEditor from "./itemEditor/FitnessPlanItemEditor";
import FoodGroupItemEditor from "./itemEditor/FoodGroupItemEditor";
import FoodOptionsItemEditor from "./itemEditor/FoodOptionsItemEditor";
import GenericItemEditor from "./itemEditor/GenericItemEditor";
import GoalMetricItemEditor from "./itemEditor/GoalMetricItemEditor";
import HabitItemEditor from "./itemEditor/HabitItemEditor";
import HabitsPlanItemEditor from "./itemEditor/HabitsPlanItemEditor";
import HealthTargetItemEditor from "./itemEditor/HealthTargetItemEditor";
import HealthTargetsWrapperItemEditor from "./itemEditor/HealthTargetWrapperItemEditor";
import LabTestItemEditor from "./itemEditor/LabTestItemEditor";
import LCGoalItemEditor from "./itemEditor/LCGoalItemEditor";
import { default as LifeStyleItemEditor } from "./itemEditor/LifeStyleItemEditor";
import MindfulnessPlanGuidelinesItemEditor from "./itemEditor/MindfulnessPlanGuidelinesItemEditor";
import MindfulnessPlanItemEditor from "./itemEditor/MindfulnessPlanItemEditor";
import OtherGoalItemEditor from "./itemEditor/OtherGoalItemEditor";
import PsychiatricHistoryItemEditor from "./itemEditor/PsychiatricHistoryItemEditor";
import PsychiatricHistoryRepeatItemEditor from "./itemEditor/PsychiatricHistoryRepeatItemEditor";
import SurgeryItemEditor from "./itemEditor/SurgeryItemEditor";
import TrackableSymptomItemEditor from "./itemEditor/TrackableSymptomItemEditor";
import WorkoutPreferenceItemEditor from "./itemEditor/WorkoutPreferenceItemEditor";
import HealthTargetItemView from "./itemView/HealthTargetItemView";
import HealthTargetsWrapperItemView from "./itemView/HealthTargetsWrapperItemView";
import PatientRedFlagsEditor from "./patient/edit/PatientRedFlagsEditor";

let allMyComponents: { [index: string]: any } = {
    "allConditions": ConditionItemWrapperEditor,
    "condition": ConditionItemEditor,
    "surgeryAndProcedure": SurgeryItemEditor,
    "concern": ConcernItemEditor,
    "redFlags": PatientRedFlagsEditor,
    "allergy": AllergyItemEditor,
    "habit": HabitItemEditor,
    "currentMedication": CurrentMedicationItemEditor,
    "lifeStyle": LifeStyleItemEditor,
    "labTest": LabTestItemEditor,
    "diagnosticlabTest": DiagnosticLabTestItemEditor,
    // "dailyRoutine": DailyRoutineEditor,
    "doctorReferral": DoctorReferralItemEditor,
    "psychiatric": PsychiatricHistoryItemEditor,
    "psychiatricRepeatingElements": PsychiatricHistoryRepeatItemEditor,
    "caseSummary": CaseSummaryItemEditor,
    "dietTheme": DietThemeItemEditor,
    "dietGuidelines": DietGuidelineItemEditor,
    "fitnessPlan": FitnessPlanItemEditor,
    "mindfulnessPlan": MindfulnessPlanItemEditor,
    "habitsPlan": HabitsPlanItemEditor,
    "dietRecall": DietRecallItemEditor,
    "healthTarget": HealthTargetItemEditor,
    "healthTargetView": HealthTargetItemView,
    "goalItemWrapper": HealthTargetsWrapperItemEditor,
    "goalItemWrapperView": HealthTargetsWrapperItemView,
    "otherGoal": OtherGoalItemEditor,
    "goalMetric": GoalMetricItemEditor,
    "foodGroups": FoodGroupItemEditor,
    "workoutPreference": WorkoutPreferenceItemEditor,
    "foodOptions": FoodOptionsItemEditor,
    "trackableSymptom": TrackableSymptomItemEditor,
    "fitnessPlanGuidelines": FitnessPlanGuidelinesItemEditor,
    "mindPlanGuidelines": MindfulnessPlanGuidelinesItemEditor,
    "genericItemEditor": GenericItemEditor,
    "lcGoalItemEditor": LCGoalItemEditor
}

interface TemplatedListProps {
    templateName: string,
    listItems: any,
    defaultItem?: any,
    id?: any,
    questionKey?: string,
    commonProps: any,
    removeBtnOnTop?: boolean,
    item?: any,
    hideRemoveBtn?: boolean,
    onItemRemove?: (index: number) => void,
    onItemChange?: (updatedItem: any, index: number) => void,
    templatedListValidations?: (value: any, index: number) => void,
    autoAddNewRow?: boolean,
    addRowText?: string,
    preventRowAddition?: boolean,
    allSelectedMealSlots?: IDietRecallMealItem[],
    onClickRemove?: (index: number) => void,
    isViewOnly?: boolean,
    validations?: any,
    question?: [],
    handleListItemClick?: (event: any, data?: {inputType: string, inputValue?: string | number, field?: string}) => void
}

interface TemplatedListState {
    showNewRow: boolean,
    isShownBelow: string
}

class TemplatedList extends React.Component<TemplatedListProps, TemplatedListState> {

    constructor(props: TemplatedListProps) {
        super(props);
        this.state = {
            showNewRow: false,
            isShownBelow: 'false',
        }
    }

    componentWillReceiveProps(nextProps: TemplatedListProps, nextState: TemplatedListState) {
        if (nextProps.listItems.length !== this.props.listItems.length) {
            this.setState({
                showNewRow: false,
            })
        }
        this.setState({
            isShownBelow: localStorage.getItem('noPresentingIllness')
        })
    }
    componentWillMount(){
        try{
            this.setState({
                isShownBelow: localStorage.getItem('noPresentingIllness')
            })
        }catch(e){
            console.log(e)
        }
       
    }
    
    toggleNewRowStatus = (status: boolean) => {
        this.setState({
            showNewRow: status
        })
    }

    handleItemChange = (updatedItem: any, index: number) => {
        this.props.onItemChange({ item: updatedItem }, index);
    }
    handleValidations = (validations: any, index: number) => {
        this.props.templatedListValidations(validations, index)
    }

    render() {
        let onTop = this.props.removeBtnOnTop !== undefined && this.props.removeBtnOnTop ? "stickToTop" : "";
        // let isHidden = this.props.hideRemoveBtn !== undefined && this.props.hideRemoveBtn ? "hidden" : "";
        let hideRemoveBtnStatus = this.props.hideRemoveBtn !== undefined && this.props.hideRemoveBtn ? "hidden" : "";
        let currTemplatedList = this;
        let currProps = { ...currTemplatedList.props.commonProps };
        let autoAdd = this.props.autoAddNewRow !== undefined ? this.props.autoAddNewRow : true;
        let autoAddText = !_.isEmpty(this.props.addRowText) ? this.props.addRowText : "Add Another";
        let showNewRow = this.state.showNewRow;
        let getLogData = this.state.isShownBelow;
        let sectionName = this.props.questionKey;
        let currListItems = Object.assign([], this.props.listItems);
        let toggleNewRow = this.toggleNewRowStatus;
        currListItems.push(this.props.defaultItem);
        return (
            <div className={`templated-items ` } id = {`${currTemplatedList.props.templateName}`} >
            {
                _.map(currListItems, function(listItem, index: number){
                    let CurrTemplate = allMyComponents[currTemplatedList.props.templateName];

                    let rowCls = index === currListItems.length - 1 ? "skip-remove" : "";
                    let isHidden = "";
                    listItem['index'] = index;
                    listItem['basic'] = currTemplatedList.props;
                    let {validations} = currTemplatedList.props;
                    if (listItem.item && listItem.item.showRemove !== undefined) isHidden = listItem.item.showRemove ? "" : "hidden";
                    validations = validations && validations.length > 0 ? validations[index] : null;
                    let currProps = {...currTemplatedList.props.commonProps, templateIndex: index, isViewOnly: currTemplatedList.props.isViewOnly, validations}
                    if (index !== currListItems.length - 1) currProps.itemIndex = index + 1;
                    if (!autoAdd && index !== 0 && index === currListItems.length - 1 && !showNewRow) {
                        return <div key={index} className={`add-row-label-container ${currTemplatedList.props.preventRowAddition ? "hidden" : ""}`}><input type="button" value={autoAddText} onClick={() => toggleNewRow(true)}/></div>
                    } else {
                        return getLogData == 'true' && sectionName === 'patientComplaints' ? '' :(
                            <div  key={index} className={"template-row " + rowCls} >
                                <div className={`template-item`}>
                                    <CurrTemplate {...listItem}
                                      {...currProps}
                                      validationHandler={(validations: any) => currTemplatedList.handleValidations(validations, index)}
                                       onDataChange={(updatedItem: any) => currTemplatedList.handleItemChange(updatedItem, index)}
                                        allSelectedMealSlots={currTemplatedList.props.allSelectedMealSlots}
                                        templateKey={index}/>
                                </div>
                                <div className={`remove-btn ${onTop} ${isHidden} ${hideRemoveBtnStatus}`} onClick={() => currTemplatedList.props.onItemRemove(index)}>
                                        <img src={ORION_IMG_URL + "remove-icon.png"}/>
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            </div>
        );
    }
}

export default TemplatedList